module.exports = __webpack_public_path__ + "img/cut_xianlai1.eb3891bf.png";